import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['nav', 'link', 'mobileButton', 'logo'];
  static values = {
    logoWhite: String,
    logoBlue: String,
  };

  connect() {
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.handleScroll);
    // Check initial scroll position
    this.handleScroll();
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const scrollPosition = window.scrollY;

    if (scrollPosition > 50) {
      // Add white background and shadow
      this.navTarget.classList.add('tw-bg-white', 'tw-shadow-md');
      this.navTarget.classList.remove('tw-bg-transparent');

      // Change link colors to dark
      this.linkTargets.forEach((link) => {
        link.classList.remove('tw-text-white', 'hover:tw-text-yellow-200');
        link.classList.add('tw-text-gray-800', 'hover:tw-text-blue-600');
      });

      // Change mobile button to dark
      if (this.hasMobileButtonTarget) {
        this.mobileButtonTarget.classList.remove('tw-text-white');
        this.mobileButtonTarget.classList.add('tw-text-gray-800');
      }

      // Change logo to blue version
      if (this.hasLogoTarget && this.hasLogoBlueValue) {
        this.logoTarget.src = this.logoBlueValue;
      }
    } else {
      // Remove white background
      this.navTarget.classList.remove('tw-bg-white', 'tw-shadow-md');
      this.navTarget.classList.add('tw-bg-transparent');

      // Restore white link colors
      this.linkTargets.forEach((link) => {
        link.classList.remove('tw-text-gray-800', 'hover:tw-text-blue-600');
        link.classList.add('tw-text-white', 'hover:tw-text-yellow-200');
      });

      // Restore mobile button to white
      if (this.hasMobileButtonTarget) {
        this.mobileButtonTarget.classList.remove('tw-text-gray-800');
        this.mobileButtonTarget.classList.add('tw-text-white');
      }

      // Restore logo to white version
      if (this.hasLogoTarget && this.hasLogoWhiteValue) {
        this.logoTarget.src = this.logoWhiteValue;
      }
    }
  }
}
